import { Component } from '@angular/core';
import { AuthService } from 'src/services';
import { NavigationService } from 'src/services/navigation.service';

@Component({
  selector: 'app-container-types',
  templateUrl: './container-types.component.html',
  styleUrl: './container-types.component.scss'
})
export class ContainerTypesComponent 
{

  constructor(private navigationService: NavigationService, private authService: AuthService) 
    { 
  
    }
    
  printPage() {
    window.print();
  }

  copyFullPageText() {
    // Get all text from the body of the document
    const textToCopy = document.body.innerText;

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.authService.showToast('error',"All text on the page has been copied!");
    }).catch(err => {
      console.error("Failed to copy text: ", err);
    });
  }
}
